import AccountSubMenuItems from '@popup/steem/pages/app-container/settings/accounts/account-sub-menu-items';
import { Screen } from '@reference-data/screen.enum';
import React from 'react';
import { connect } from 'react-redux';
import { MenuComponent } from 'src/common-ui/menu/menu.component';
const AccountSubMenu = ({}) => {
    return (React.createElement("div", { "data-testid": `${Screen.SETTINGS_ACCOUNTS}-page`, className: "settings-account-sub-menu-page" },
        React.createElement(MenuComponent, { title: "popup_html_accounts", isBackButtonEnable: true, menuItems: AccountSubMenuItems })));
};
const mapStateToProps = (state) => {
    return {};
};
const connector = connect(mapStateToProps, {});
export const AccountSubMenuComponent = connector(AccountSubMenu);
